import {Typography} from '@mui/material'

const CustomTooltip = ({active, payload, label}) => {
    if (active && payload && payload.length) {
        return (
            <div style={{background: '#CBDDEE', padding: 8, borderRadius: 4}}>
                <Typography className="label">{payload[0].value}</Typography>
            </div>
        )
    }

    return null
}

export default CustomTooltip
